<template>
    <div>
        <b-form-group label="value[0]"
                      label-size="sm"
                      :label-cols-sm="1">
            <template #description>
                Set value or FDO reference.
                <ul>
                    <li>if fdo[0] is an object: check if value[0][value[1]] is in value[2]</li>
                    <li>if fdo[0] is a string/number: check if value[0] is in value[2]</li>
                    <li>if fdo[0] is an array: check if value[0][value[1]] is in value[2] for each array item in
                        value[0]
                    </li>
                </ul>
            </template>
            <JsonEditor :data-input="value[0]" @data-output="(data) => (value[0] = data)"></JsonEditor>
        </b-form-group>

        <b-form-group label="value[1]"
                      label-size="sm"
                      :label-cols-sm="1"
                      description="Key name of object">
            <b-form-input size="sm"
                          v-model="value[1]"></b-form-input>
        </b-form-group>
        <b-form-group label="value[2]"
                      label-size="sm"
                      :label-cols-sm="1"
                      description="Array of values">
            <JsonEditor :data-input="value[2]===undefined?[]:value[2]"
                        @data-output="(data) => (value[2] = data)"></JsonEditor>
        </b-form-group>
        <b-form-group label="POSITIVE"
                      label-size="sm"
                      :label-cols-sm="1">
            <b-form-select size="sm"
                           v-model="value_positive"
                           :options="opts"></b-form-select>
        </b-form-group>

        <b-form-group label="AND"
                      label-size="sm"
                      :label-cols-sm="1">
            <b-form-select size="sm"
                           v-model="value_and"
                           :options="opts"></b-form-select>
            <template #description>
                <ul>
                    <li>if "and": true, the activation rule is true if all are in</li>
                    <li>if "and": false, the activation rule is true if one of them is in</li>
                </ul>
            </template>
        </b-form-group>
    </div>
</template>

<script>
import valueCmp from "./mixins/valueCmp";

export default {
    mixins: [valueCmp],
    computed: {
        opts() {
            return [{value: true, text: 'true'}, {value: false, text: 'false'}]
        },
        value_positive: {
            get() {
                return this.value[3]?.positive
            },
            set(val) {
                if (!this.value[3]) {
                    this.value[3] = {positive: true, and: true}
                }
                this.value[3].positive = val
            }
        },
        value_and: {
            get() {
                return this.value[3]?.and
            },
            set(val) {
                if (!this.value[3]) {
                    this.value[3] = {positive: true, and: true}
                }
                this.value[3].and = val
            }
        }
    }
}
</script>

<style scoped>

</style>
